<div class="local-attachment-header">
  <div class="hd-icon hd-icon-attachment"></div>
  <div class="local-attachment-caption">{{'filePreview_Activitytype_Attachment' | xsI18n}}</div>

  <button [sotiPopupTriggerFor]="popupDelete" type="button"
    class="icon-md hd-icon-delete delete-attachment-button"></button>
  <soti-popup #popupDelete="sotiPopup" position="endBottom" [offsetY]="-10" [offsetX]="3">
    <div *sotiPopupContent class="popup-container">
      <div class="popup-title">{{ 'popover_Confirm_Title' | xsI18n }}</div>
      <div class="popup-body-text">
        <p>{{ 'attachment_DeleteConfirmation' | xsI18n }}</p>
      </div>
      <div class="popup-footer">
        <button class="xsight-button flat btn-cancel" (click)="cancelDelete($event)">{{ 'xs_cancel_label_short' | xsI18n }}</button>
        <button class="xsight-button danger" (click)="delete()">{{ 'xs_delete_label' | xsI18n }}</button>
      </div>
      <div class="popup-menu-beak"></div>
    </div>
  </soti-popup>
</div>
<div class="local-attachment-body">
  <div class="local-attachment-details">
    <div class="local-attachment-file-name">
      <span>{{parentActivity.fileName}}</span>
    </div>
    <div class="local-attachment-file-size"> ({{parentActivity.fileSize | xsFileSizeFormatPipe}}) </div>
  </div>
</div>

<div class="local-attachment-note">
  <div class="text-input-control">
    <textarea
      class="text-input-field ng-pristine ng-untouched ng-valid-maxlength ng-not-empty ng-valid ng-valid-required"
      maxlength="4000" [(ngModel)]='this.parentActivity.description' rows="1"
      placeholder="{{'attachment_description' | xsI18n}}"></textarea>
  </div>
</div>
